import React from 'react';
import "./BackgroundForm.css";

function BackgroundForm({children, className = ''} ) {
    return (
        <div className={"background-form" + (className ? " " + className : "")}>
            {children}
        </div>
    );
}


export default BackgroundForm;